import React from 'react';
import * as IptC from './_ccbIptC';
import * as TextC from './_ccbTextC';
import * as BtnC from './_cccBtnC';
import * as GridC from './_cccGridC';
import * as LblC from './_cccLblC';
import * as BtnsC from './_ccmBtnsC';
import * as HdrC from './_ccmHdrC';
import * as RootC from './_ccmRootC';
import * as SchC from './_ccmSchC';
import * as TblC from './_ccmTblC';
import * as _cm from './_cm';
import { a } from './_cmABT';
import * as _cmFTH from './_cmFTH';
import * as _cr from './_cr';
import * as _gv from './_gv';
import * as _ls from './_csLcl';
import { useNgnz } from './_csNgn';
import * as _hm from './_hm';
import * as _ht from './_ht';

import * as icv from './icv';
import * as icvBaseM10Rz from './icvBaseM10Rz';

const $cz = {
  tgt: '店種',
};

let $i12z = {} as _ht.dz;

let $i12rs = [] as _ht.ls;

let $i12r_fst = -1;

const $schz = {
  word: '',
};

const $schAsync = async (
  frcUdt: () => void
) => {
  //_hm.l(`icvi12M10Rz 42: ${_hm.s($schz)}`)
  $i12rs = await _cmFTH.loadLsAsync2({
    tgt: 'i12r.loadI12zLsAsync',
    tailz: {
      odr: '_icn::NUMERIC'
    },
    ... $schz,
  });
  if (frcUdt) frcUdt();
};

export const R = (pz: {
  sRz: _ht.dz,
}) => {

  const _sPz = _ls.usePz({
    steps: [0],
    phs: 'd',
  });

  return (
    _cr.c(icvBaseM10Rz.N, {},
      _cr.c(RootC.N, {
        sPz: _sPz,
        hdrClds: [
          _cr.c(H, {
            sPz: _sPz,
          })
        ],
        schStlz: a(`dw/w3`),
        schClds: [
          _cr.c(S, {
            sPz: _sPz,
          })
        ],
        btnClds: [
          _cr.c(B, {
            sPz: _sPz,
          })
        ],
        topStlz: a(`dw/w3`),
        topClds: [
          _cr.c(T, {
            sPz: _sPz,
          })
        ],
        cttClds: [
          _cr.c(C, {
            sPz: _sPz,
          })
        ],
      })
    )
  );

};

export const H = (pz: {
  sPz: _ht.dz,
}) => {
  return (
    _cr.c(HdrC.N, {
      sPz: pz.sPz,
      abtz: icv.abtz.mainHdrz,
      cz: {
        tgt: $cz.tgt
      }
    })
  );
};

export const S = (pz: {
  sPz: _ht.dz,
}) => {
  return (
    _cr.c(SchC.N, {
      sPz: pz.sPz,
      abtz: {
        btnSchz: icv.abtz.btnSchz,
        gridSchz: icv.abtz.gridSchz,
      },
      schClds: [
        _cr.c(IptC.N, {
          cz: {
            bEdit: true,
            iptType: 't',
            vle: $schz.word,
            onChg: (_s: _ht.s) => {
              $schz.word = _s;
            },
          },
          iptPtyz: a(`ipt/${$cz.tgt}ID、${$cz.tgt}名 ipc/lt3`),
        }),
      ],
      onSch: () => $schAsync(pz.sPz.udtAll),
    })
  );
};

export const T = (pz: {
  sPz: _ht.dz,
}) => {

  const _udtThis = _ls.udtThis();
  const _gUserz = _gv.useUserz();

  React.useEffect(() => {
    if (
      _gUserz.crt._20rz._key > 0 && 
      pz.sPz.crt.steps[0] == 0
    ) {
      _hm.ectSrlAsync([
        async () => {
          await $schAsync(_udtThis);
        },
      ])
    }
  }, [
    _gUserz.crt._20rz._key,
    pz.sPz.crt.steps[0]
  ])

  const _hdrCs = [
    {
//      boxStlz: a(`dw/f fd/rsc mb/1`),
      cellCs: [
        {
          boxStlz: a(`dw/icn`),
          boxClds: [
            _cr.c(TextC.N, {
              abtz: icv.abtz.textLblz,
              text: `${$cz.tgt}ID`,
            }),
          ]
        },
        {
          boxStlz: a(`f/1`),
          boxClds: [
            _cr.c(TextC.N, {
              abtz: icv.abtz.textLblz,
              text: `${$cz.tgt}名`,
            }),
          ]
        },
        {
          boxStlz: a(`dw/btn`),
          boxClds: [

          ]
        }
      ]
    }
  ];

  const _bdyCs = $i12rs?.map((_i12rz: _ht.dz) => {
    return (
      {
//        boxStlz: a(`dw/f fd/rsc mb/1`),
        cellCs: [
          {
            boxStlz: a(`dw/icn`),
            boxClds: [
              _cr.c(TextC.N, {
                abtz: icv.abtz.textVlez,
                text: `${_i12rz._icn}`,
              }),
            ]
          },
          {
            boxStlz: a(`f/1 fd/rsc`),
            boxClds: [
              _cr.c(TextC.N, {
                abtz: icv.abtz.textVlez,
                text: `${_i12rz._pfx}`,
              }),
            ]
          },
          {
            boxStlz: a(`dw/btn`),
            boxClds: [

              _cr.c(BtnC.N, {
                abtz: icv.abtz.btnDtlz,
                frmCz: {
                  pslPtyz: {
                    onPrs: () => {
                      $i12r_fst = _i12rz._fst;
                      pz.sPz.set({
                        steps: [1],
                        phs: 'd',
                      })
                    }
                  }            
                },
              }),

            ]
          }
        ]
      }
    );
  });

  return (
    _cr.c(TblC.N, {
      abtz: icv.abtz.tblLinez,
      hdrCz: {
        abtz: icv.abtz.gridTblHdrz,
        lineCs: _hdrCs,
      },
      bdyCz: {
        abtz: icv.abtz.gridTblBdyz,
        lineCs: _bdyCs
      }
    })

  );

};

export const C = (pz: {
  sPz: _ht.dz,
}) => {

  const _udtThis = _ls.udtThis();

  React.useEffect(() => {
    if ( pz.sPz.crt.steps[0] == 1 && pz.sPz.crt.phs == 'c' ) { // 初期化
      $i12z = {
        i12rz: {},
      };
      _udtThis();
    };
    if ( pz.sPz.crt.steps[0] == 1 && pz.sPz.crt.phs == 'd' ) { // 更新
      _cmFTH.loadDzAsync2({
        tgt: 'i12r.loadI12zDzAsync',
        i12r_fst: $i12r_fst
      })
      .then((_i12z: _ht.dz) => {
        $i12z = _i12z;
        _udtThis();
      });
    };
  }, [
    pz.sPz.crt.steps[0],
    pz.sPz.crt.phs
  ])

  return (
    _cr.c(GridC.N, {
      abtz: icv.abtz.gridCttz,
      lineCs: [
        {
          cellCs: [
            {
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text: `${$cz.tgt}ID：`,
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 't',
                          bEdit: _hm.i(pz.sPz.crt.phs, ['c', 'u']),
                          vle: $i12z.i12rz?._icn,
                          onChg: (_s: _ht.s) => {
                            _cm.u($i12z.i12rz, {
                              _icn: _s,
                            });
                          }
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },
        {
          cellCs: [
            {
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text: `${$cz.tgt}名：`,
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 't',
                          bEdit: _hm.i(pz.sPz.crt.phs, ['c', 'u']),
                          vle: $i12z.i12rz?._pfx,
                          onChg: (_s: _ht.s) => {
                            _cm.u($i12z.i12rz, {
                              _pfx: _s,
                            });
                          }
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },
      ]
    })

  );

};

const $upsAsync = async (sCfmz: _ht.dz) => {
  await _cmFTH.ugdDzAsync2({
    tgt: 'i12r.ugdI12zDzAsync',
    i12z: $i12z,
  })
  .then((_i12z: _ht.dz) => {
    $i12r_fst = _i12z.i12rz._fst;
  });
};

export const B = (pz: {
  sPz: _ht.dz,
}) => {

  const _sNgnz = useNgnz();

  return (
    _cr.c(BtnsC.N, {
      sPz: pz.sPz,
      abtz: {
        gridBtnz: icv.abtz.gridBtnz,
        btnNextz: icv.abtz.btnNextz,
        btnBackz: icv.abtz.btnBackz,
      },
      cz: {
        tgt: $cz.tgt,
        onBackTop: () => {
          _sNgnz.setPageName('icvHomeM20Rz');
        },
        onCrtAsync: $upsAsync,
        onUdtAsync: $upsAsync,
      }
    })  
  );

};
